export const AuthCheck = (action) => {
  if (action.error.status == 401) return (window.location.href = '/login')
}
